
import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';

import { Email } from '../../interfaces/customer-info/email';
import { Phone } from '../../interfaces/customer-info/phone';
import { Address } from '../../interfaces/customer-info/address';
import { PhoneService } from '@core-services/phone/phone.service';
import { EmailsListComponent } from '../emails-list/emails-list.component';
import { PhonesListComponent } from '../phones-list/phones-list.component';
import { AddressesListComponent } from '../addresses-list/addresses-list.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'general-info',
    templateUrl: './general-info.component.html',
    styleUrls: ['../general-info-base/general-info-base.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [EmailsListComponent, PhonesListComponent, AddressesListComponent, TranslateModule]
})
export class GeneralInfoComponent implements OnInit {
    @Input() public isPrimaryCustomer: boolean;
    @Input() public isSelfProfile: boolean;
    @Input() public emails: Email[];
    @Input() public phones: Phone[];
    @Input() public addresses: Address[];
    @Input() public isFullVersion = true;

    public readonly phoneService = inject(PhoneService);

    public ngOnInit(): void {
        this.phoneService.loadCountryPhoneInfo();
    }
}
